module.exports = __webpack_public_path__ + "static/media/home.04ada035.svg";